import {v3, v2, quat} from "oc-threejs/short3.js";
import Textures from "oc-threejs/Textures.js";
import Scenes from "oc-threejs/Scenes.js";
import Connector from "./Connector";
// import dat from 'dat-gui';

/**
 * Visualisierung eines Connectors
 */
export default class ConnectorHelper extends THREE.Object3D {

    /** @type {Connector} */
    connector;

    /**
     * Creates an instance of ConnectorHelper.
     * @param {Connector} connector
     */
    constructor(connector) {
        super();
        this.connector = connector;

        this.name=this.figure+'Helper';

        if (STAGE.settings.showDebugObjects) {
            this.addDebugObjects();

        }

        if (this.figure != 'Anchor') {
            this.addPulseRings();
        }



        this.hideTori();
    }

    addDebugObjects() {
        this.add(new THREE.ArrowHelper(v3(1, 0, 0), v3(0, 0, 0), this.size, 0xff0000));
        this.add(new THREE.ArrowHelper(v3(0, 1, 0), v3(0, 0, 0), this.size, 0x00ff00));
        this.add(new THREE.ArrowHelper(v3(0, 0, 1), v3(0, 0, 0), this.size, 0x0000ff));
        this.addIf(this.figureBox());
        this.debugConnectedMarker = new THREE.Mesh(new THREE.TorusGeometry(1.5 * this.size, 0.3 * this.size, 10, 16), new THREE.MeshBasicMaterial({
            color: 0xF0F000,
            side: THREE.DoubleSide
        }));
        this.add(this.debugConnectedMarker);
        this.connector.on('connect', () => this.showConnected(true));
        this.connector.on('disconnect', () => this.showConnected(false));

        this.showConnected(false);
    }

    get size() {
        return STAGE.settings.connectors.size;
    }

    get markerSettings() {
        return STAGE.settings.connectors.markers;
    }

    addIf(child) {
        if (child) {
            this.add(child);
        }
    }

    showConnected(on) {
        this.debugConnectedMarker.visible = on;
        Textures.setOpacity(this.debugConnectedMarker, on ? 1 : 0);
    }

    get figure() {
        return this.connector.type.figure;
    }

    figureBox() {
        switch (this.figure) {
            case 'Anchor': {
                const box = Scenes.box(v3(3 * this.size, 0.3 * this.size, 3 * this.size), {color:0x404040});
                box.position.set(0 * this.size, 0 * this.size, 0 * this.size);
                return box;
            }
            case 'Magnet': {
                const box = Scenes.box(v3(2 * this.size, 2 * this.size, 1 * this.size), {color:0x808080});
                box.position.set(0 * this.size, 0 * this.size, -0.5 * this.size);
                return box;
            }
            case 'Eyelet':
                return new THREE.Mesh(new THREE.TorusGeometry(1 * this.size, 0.2 * this.size, 10, 16), new THREE.MeshBasicMaterial({
                    color: 0xB00000,
                    side: THREE.DoubleSide
                }));
            case 'Hook':
                return new THREE.Mesh(new THREE.CylinderGeometry(0 * this.size, 1 * this.size, 2 * this.size, 16, 1), new THREE.MeshBasicMaterial({
                    color: 0x00B000,
                    side: THREE.DoubleSide
                })).rotateX(90 * Math.PI / 180);
        }
    }

    addPulseRings() {
        this.torus = [];
        const tori = this.markerSettings.tori;
        for (let i = 0; i < tori; i++) {
            this.torus.push(this.newTorus(this.markerSettings.radius * (i + 1), this.markerSettings.tube * (tori - i + 1), 0xf0f000));
        }
        this.torus.forEach(t=>this.add(t));

    }

    onAnimatorTick(now, tags) {
        if (!this.torus) {
            return;
        }
        if (tags.has('drag')) {
            this.torus.forEach((torus, i)=> {
                if (this.connector.pulseStrength>0.1) {
                    const opacity = Math.sin((i * this.markerSettings.alpha + now * this.markerSettings.speed) * Math.PI / 180) * (1 - i * this.markerSettings.ab);
                    const s = this.connector.pulseStrength;
                    if (s > 1-Connector.EPSILON) {
                        torus.material.opacity = opacity;
                        torus.material.color = new THREE.Color(0xaaff00);
                    } else {
                        torus.material.opacity = opacity*s;
                        torus.material.color = new THREE.Color(0xffff00);
                    }
                    torus.material.needsUpdate = true;
                    torus.visible = true;
                } else {
                    torus.visible = false;
                }
            });
        } else {
            this.hideTori();
        }
    }

    hideTori() {
        if (!this.torus) {
            return;
        }
        this.torus.forEach(torus=> {
            Textures.setOpacity(torus, 0);
            torus.visible = false;
        })
    }

    newTorus(r, s, color) {
        return new THREE.Mesh(new THREE.TorusGeometry(r, s, this.markerSettings.radialSegments, this.markerSettings.tubularSegments), new THREE.MeshBasicMaterial({
            color,
            side: THREE.DoubleSide
        }));
    }

    /*
    static showConnectorMarkGUI() {
        const gui = new dat.GUI();
        const connectors = STAGE.settings.connectors;
        gui.add(connectors, 'size', 0, 1).step(0.05);
        gui.add(connectors, 'anchorsAreGroundedDistance', 0, 5).step(0.05);
        gui.add(connectors, 'distanceWhereForceIs0', 0, 10).step(0.05);
        gui.add(connectors, 'distanceWhereForceIs1', 0, 10).step(0.05);
        gui.add(connectors, 'distanceWhereForcePulseIs0', 0, 10).step(0.05);
        gui.add(connectors, 'distanceWhereForcePulseIs1', 0, 10).step(0.05);
        gui.add(connectors, 'PulseFactor', 0, 100).step(1);
        gui.add(connectors, 'PulseGroudLine', 0, 10).step(0.05);
        gui.add(connectors, 'snapDistance', 0, 10).step(0.05);
        const markers = connectors.markers;
        gui.add(markers, 'alpha', 0, 360).step(0.5);
        gui.add(markers, 'speed', 0, 2).step(0.05);
        gui.add(markers, 'ab', 0, 1).step(0.01);
        gui.add(markers, 'tori', 0, 10).step(1);
        gui.add(markers, 'radius', 0, 10).step(0.1);
        gui.add(markers, 'tube', 0, 3).step(0.01);
        gui.add(markers, 'radialSegments', 1, 20).step(1);
        gui.add(markers, 'tubularSegments', 1, 30).step(1);
    }
   */

}
